import { create } from 'zustand';

interface GenerationState {
  prompt: string;
  reference: null | {
    versionId: string; // version id from Project.contentVersionMeta
    pageId: string; // grapes page id (snapshot id)
  };
  isGenerating: boolean;
  action: 'generate' | 'improve' | null;
  error: string | null;
  warnings: string[];
  abortController: AbortController | null;

  setPrompt: (text: string) => void;
  setReference: (ref: GenerationState['reference']) => void;
  startGeneration: (controller: AbortController, action?: GenerationState['action']) => void;
  generationSuccess: () => void;
  generationError: (message: string) => void;
  cancelGeneration: () => void;
  clearError: () => void;
  setWarnings: (warnings: string[]) => void;
  clearWarnings: () => void;
}

export const useGenerationStore = create<GenerationState>()((set, get) => ({
  prompt: '',
  reference: null,
  isGenerating: false,
  action: null,
  error: null,
  warnings: [],
  abortController: null,

  setPrompt: (prompt) => set({ prompt }),
  setReference: (reference) => set({ reference }),
  startGeneration: (controller, action) =>
    set({ isGenerating: true, action: action ?? 'generate', error: null, warnings: [], abortController: controller }),
  generationSuccess: () => set({ isGenerating: false, action: null, abortController: null }),
  generationError: (error) => set({ isGenerating: false, action: null, error, abortController: null }),
  cancelGeneration: () => {
    const { abortController } = get();
    if (abortController) {
      abortController.abort();
      set({ isGenerating: false, action: null, abortController: null, error: 'Generation cancelled' });
    }
  },
  clearError: () => set({ error: null }),
  setWarnings: (warnings) => set({ warnings }),
  clearWarnings: () => set({ warnings: [] }),
}));
